import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../../data/landing";
import { SectionHeading } from "../SectionHeading";
import { TransformCta } from "../TransformCta";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-5 py-16" data-id="element-121" data-mp="124pq797wzjjj">
      <SectionHeading eyebrow="Frequently asked questions" title="Answers before you decide" data-id="element-122" data-mp="1prxsrjdykehv" />
      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-123" data-mp="1uru1fvxlou3r">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} className="overflow-hidden rounded-2xl bg-cream ring-1 ring-navy/10" data-id="element-124" data-mp="1g24lgukumljf" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[17px] font-bold text-ink" data-id="element-125" data-mp="1kzoampj34iq5">
                <span data-id="element-126" data-mp="2oqibls0ulm8f">{f.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-127" data-mp="2jr5rvg59wva2" />
              </button>
              <AnimatePresence initial={false} data-id="element-128" data-mp="2tojti9mjffib">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-129" data-mp="37fxbvk8pm7br">
                    <p className="px-5 pb-5 leading-relaxed text-muted" data-id="element-130" data-mp="3cfjobrgprjji">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
      <TransformCta label="I'm ready — give me the Blueprint" data-id="element-131" data-mp="1i2tuf9qciac4" />
    </section>;
}